// src/data/planning/corePlanTemplate.js

/**
 * 2026-2027
 * Rehber360 Standart Plan Robotu
 *
  * Burada faaliyet isimleri YAZILMAZ.
 * Yalnızca doğrulanmış resmî katalog ID'leri kullanılır:
 * - officialActivityCatalog
 * - targetActivityCatalog
 */

export const CORE_PLAN_VERSION = "2026-2027-V1";


export const REGULAR_SCHOOL_CORE_PLAN = [

  // ---------------------------------------------------------
  // SENE BAŞI
  // ---------------------------------------------------------

  {
    id: "core_decimal",

    activityId: "service_decimal_file_creation",

    mebbisCode: "DP",

       timing: {
      type: "school_week",
      week: 1
    },

    selectionMode: "default",

    order: 10
  },

  {
    id: "core_commission_creation",

    activityId: "rpd_commission_creation",

    mebbisCode: "DP",

        timing: {
      type: "school_week",
      week: 1
    },

    selectionMode: "locked",

    order: 20
  },

  {
    id: "core_program_preparation",

    activityId: "annual_rpd_program_preparation",
    
    mebbisCode: "DP",

        timing: {
      type: "school_week",
      week: 1
    },

    selectionMode: "locked",

    order: 30
  },

   {
    id:
      "core_school_environment_adaptation",

    activityId:
      "school_environment_adaptation",

    mebbisCode:
      "ÖOVEg",

    timing: {
      type: "month",
      month: 9
    },

    applicableSchoolLevels: [
      "preschool",
      "primary",
      "middle_school",
      "high_school",
      "vocational_high_school"
    ],

    selectionMode: "default",

    order: 32
  },

  
    {
    id:
      "core_guidance_service_intro",

    sourceCatalog:
      "targetActivityCatalog",

    activityId:
      "student_academic_rehberlik_ve_psk_dan_ser_tan",

    contextLabel:
      "Rehberlik Servisinin Tanıtılması",

    activityTypeId:
      "seminar",

    timing: {
      type: "month",
      month: 9
    },

    applicableSchoolLevels: [
      "primary",
      "middle_school",
      "high_school",
      "vocational_high_school"
    ],

    selectionMode:
      "default",

    order:
      33
  },


  {
    id: "core_school_rules",

    activityId:
      "school_rules_information",

    mebbisCode:
      "ÖOVEg",

    activityTypeId:
      "publication_preparation",

    timing: {
      type: "school_start"
    },

        applicableSchoolLevels: [
      "preschool",
      "primary",
      "middle_school",
      "high_school",
      "vocational_high_school"
    ],

    selectionMode: "default",

    order: 34
  },

    {
    id:
      "core_student_information",

    activityId:
      "student_information_form",

    mebbisCode:
      "B.K.G.4.c.1",

    activityTypeId:
      "individual_recognition_techniques",

    timing: {
      type: "month",
      month: 9
    },

    selectionMode:
      "default",

    order: 40
  },


  // ---------------------------------------------------------
  // AKADEMİK DESTEK - STANDART ÇALIŞMALAR
  // ---------------------------------------------------------


  /*
   * VERİMLİ DERS ÇALIŞMA TEKNİKLERİ
   *
   * Ortaokul + Lise + MTAL
   * Kademe içindeki tüm sınıflar.
   *
   * Varsayılan tür:
   * Yayın Hazırlama
   *
   * Böylece psikolojik danışmana tüm sınıflar için
   * zorunlu ayrı ayrı seminer yükü oluşturulmaz.
   */
  {
    id:
      "core_efficient_study_techniques",

    sourceCatalog:
      "targetActivityCatalog",

    activityId:
      "student_academic_verimli_ders_calisma_teknikleri",

    activityTypeId:
      "publication_preparation",

    timing: {
      type: "month",
      month: 10
    },

    applicableSchoolLevels: [
      "middle_school",
      "high_school",
      "vocational_high_school"
    ],

    selectionMode:
      "default",

    order: 41
  },


  /*
   * ÜST ÖĞRENİME GEÇİŞ SINAVLARI
   * ORTAOKUL → yalnız 8. sınıf
   */
  {
    id:
      "core_transition_exams_middle",

    sourceCatalog:
      "targetActivityCatalog",

    activityId:
      "student_academic_ust_ogrenime_gecis_sinavlari",

    activityTypeId:
      "seminar",

    timing: {
      type: "month",
      month: 12
    },

    applicableSchoolLevels: [
      "middle_school"
    ],

    applicableGrades: [
      8
    ],

    selectionMode:
      "default",

    order: 42
  },


  /*
   * ÜST ÖĞRENİME GEÇİŞ SINAVLARI
   * LİSE / MTAL → yalnız 12. sınıf
   */
  {
    id:
      "core_transition_exams_high",

    sourceCatalog:
      "targetActivityCatalog",

    activityId:
      "student_academic_ust_ogrenime_gecis_sinavlari",

    activityTypeId:
      "seminar",

    timing: {
      type: "month",
      month: 12
    },

    applicableSchoolLevels: [
      "high_school",
      "vocational_high_school"
    ],

    applicableGrades: [
      12
    ],

    selectionMode:
      "default",

    order: 43
  },


  /*
   * OKULLARA / SINAVLARA BAŞVURU KILAVUZLARI
   * ORTAOKUL → yalnız 8. sınıf
   */
  {
    id:
      "core_application_guides_middle",

    sourceCatalog:
      "targetActivityCatalog",

    activityId:
      "student_academic_okullara_sinavlara_basvuru_kilavuzlari",

    activityTypeId:
      "publication_preparation",

    timing: {
      type: "month",
      month: 2
    },

    applicableSchoolLevels: [
      "middle_school"
    ],

    applicableGrades: [
      8
    ],

    selectionMode:
      "default",

    order: 44
  },


  /*
   * OKULLARA / SINAVLARA BAŞVURU KILAVUZLARI
   * LİSE / MTAL → yalnız 12. sınıf
   */
  {
    id:
      "core_application_guides_high",

    sourceCatalog:
      "targetActivityCatalog",

    activityId:
      "student_academic_okullara_sinavlara_basvuru_kilavuzlari",

    activityTypeId:
      "publication_preparation",

    timing: {
      type: "month",
      month: 2
    },

    applicableSchoolLevels: [
      "high_school",
      "vocational_high_school"
    ],

    applicableGrades: [
      12
    ],

    selectionMode:
      "default",

    order: 45
  },


  // ---------------------------------------------------------
  // RPD HİZMETLERİ YÜRÜTME KOMİSYONU
  // ---------------------------------------------------------

  {
  id: "core_commission_meeting_1",

  activityId: "rpd_commission_meeting",

  mebbisCode: "DP",

  activityTypeId:
    "meeting",

    timing: {
      type: "school_week",
      week: 2
    },

    selectionMode: "locked",

    order: 50
  },

  {
    id: "core_commission_meeting_2",

    activityId: "rpd_commission_meeting",

    mebbisCode: "DP",

activityTypeId:
  "meeting",

    timing: {
      type: "second_term_start"
    },

    selectionMode: "locked",

    order: 60
  },

  {
    id: "core_commission_meeting_3",

    activityId: "rpd_commission_meeting",

    mebbisCode: "DP",

activityTypeId:
  "meeting",

    timing: {
      type: "school_year_end"
    },

       selectionMode: "locked",

    order: 70
  },

   // ---------------------------------------------------------
  // BEP GELİŞTİRME BİRİMİ TOPLANTILARI
  // Ekim + Şubat + Haziran
  // ---------------------------------------------------------

  {
    id: "core_bep_meeting_october",

    activityId:
      "bep_development_unit_meeting",

    mebbisCode: "DİT",

    activityTypeId: "meeting",

        timing: {
      type: "month_week",
      month: 10,
      week: 1
    },

    applicableSchoolLevels: [
      "preschool",
      "primary",
      "middle_school",
      "high_school",
      "vocational_high_school"
    ],

    selectionMode: "default",

    order: 72
  },

  {
    id: "core_bep_meeting_february",

    activityId:
      "bep_development_unit_meeting",

    mebbisCode: "DİT",

    activityTypeId: "meeting",

    timing: {
      type: "month",
      month: 2
    },

    applicableSchoolLevels: [
      "preschool",
      "primary",
      "middle_school",
      "high_school",
      "vocational_high_school"
    ],

    selectionMode: "default",

    order: 74
  },

  {
    id: "core_bep_meeting_june",

    activityId:
      "bep_development_unit_meeting",

    mebbisCode: "DİT",

    activityTypeId: "meeting",

    timing: {
      type: "month",
      month: 6
    },

    applicableSchoolLevels: [
      "preschool",
      "primary",
      "middle_school",
      "high_school",
      "vocational_high_school"
    ],

    selectionMode: "default",

    order: 75
  },

  // ---------------------------------------------------------
  // PSİKOSOSYAL KORUMA / ÖNLEME / KRİZE MÜDAHALE
  // ---------------------------------------------------------

  {
    id:
      "core_psychosocial_meeting_october",
    activityId:
      "psychosocial_protection_crisis_meeting",
    mebbisCode: "DİT",
    activityTypeId: "meeting",
    timing: {
      type: "month",
      month: 10
    },
        applicableSchoolLevels: [
      "preschool",
      "primary",
      "middle_school",
      "high_school",
      "vocational_high_school"
    ],
    selectionMode: "default",
    order: 76
  },

  {
    id:
      "core_psychosocial_meeting_february",
    activityId:
      "psychosocial_protection_crisis_meeting",
    mebbisCode: "DİT",
    activityTypeId: "meeting",
    timing: {
      type: "month",
      month: 2
    },
       applicableSchoolLevels: [
      "preschool",
      "primary",
      "middle_school",
      "high_school",
      "vocational_high_school"
    ],
    selectionMode: "default",
    order: 77
  },

  {
    id:
      "core_psychosocial_meeting_june",
    activityId:
      "psychosocial_protection_crisis_meeting",
    mebbisCode: "DİT",
    activityTypeId: "meeting",
    timing: {
      type: "month",
      month: 6
    },
       applicableSchoolLevels: [
      "preschool",
      "primary",
      "middle_school",
      "high_school",
      "vocational_high_school"
    ],
    selectionMode: "default",
    order: 78
  },

 // ---------------------------------------------------------
// KASIM - RİSK HARİTASI
// ---------------------------------------------------------

{
  id: "core_class_risk_map",

  activityId:
    "class_risk_map",

  contextLabel:
    "Sınıf Risk Haritaları",

  mebbisCode:
    "S.İ.4.a",

  activityTypeId:
    "individual_recognition_techniques",

  timing: {
    type: "month",
    month: 11
  },

    applicableSchoolLevels: [
    "preschool",
    "primary",
    "middle_school",
    "high_school",
    "vocational_high_school"
  ],

  selectionMode: "locked",

  order: 79
},

{
  id: "core_risk_map_teacher_consultancy",



  activityId: "teacher_individual_recognition_consultancy",

  contextLabel:
    "Sınıf Risk Haritası İçin Öğretmen Müşavirliği",

    mebbisCode: "DMÖE",

  timing: {
    type: "month",
    month: 11
  },

  selectionMode: "locked",

    order: 80
},

{
  id: "core_school_risk_maps",

  activityId:
    "school_risk_maps",

  mebbisCode:
    "S.İ.2.a",

  activityTypeId:
    "individual_recognition_techniques",

  timing: {
    type: "month",
    month: 11
  },

    applicableSchoolLevels: [
    "preschool",
    "primary",
    "middle_school",
    "high_school",
    "vocational_high_school"
  ],

  selectionMode: "locked",

  order: 85
},

  {
    id: "core_school_risk_map",

    activityId: "school_risk_map_creation",

    mebbisCode: "DP",

    timing: {
      type: "month",
      month: 11
    },

    selectionMode: "locked",

    order: 90
  },

  // ---------------------------------------------------------
// ŞİDDETİN ÖNLENMESİ
// ---------------------------------------------------------

{
  id: "core_violence_prevention_student",

  activityId: "violence_prevention_student",

  mebbisCode: "ÖOVKg",

  timing: {
    type: "balanced"
  },

  selectionMode: "default",

  order: 92
},

{
  id: "core_violence_prevention_parent",

  activityId: "violence_prevention_parent",

   mebbisCode: "DMVE",

  timing: {
    type: "balanced"
  },

  selectionMode: "default",

  order: 93
},

{
  id: "core_violence_prevention_teacher",

  activityId: "violence_prevention_teacher",

  mebbisCode: "DMÖE",

  timing: {
    type: "balanced"
  },

  selectionMode: "default",

  order: 94
},


// ---------------------------------------------------------
// KADINA YÖNELİK ŞİDDETİN ÖNLENMESİ
// ---------------------------------------------------------

{
  id: "core_violence_against_women_student",

  activityId: "violence_against_women_student",

   mebbisCode: "ÖOVKg",

  timing: {
    type: "balanced"
  },

  selectionMode: "default",

  order: 95
},

  // ---------------------------------------------------------
  // MAYIS - İHTİYAÇ ANALİZİ
  // ---------------------------------------------------------

  {
    id: "core_needs_analysis",

    activityId: "rpd_needs_analysis",

   mebbisCode: "DP",

    timing: {
      type: "month",
      month: 5
    },

    selectionMode: "locked",

    order: 100
  },
  
    // ---------------------------------------------------------
// MAYIS - RİBA FORMLARI
// Okul kademesine göre robot daha sonra uygun olanları seçecek.
// ---------------------------------------------------------

{
  id: "core_riba_preschool_teacher",
  activityId: "riba_preschool_teacher",

  timing: {
    type: "month",
    month: 5
  },

  applicableSchoolLevels: ["preschool"],
  selectionMode: "default",
  order: 110
},

{
  id: "core_riba_preschool_parent",
  activityId: "riba_preschool_parent",

  timing: {
    type: "month",
    month: 5
  },

  applicableSchoolLevels: ["preschool"],
  selectionMode: "default",
  order: 120
},


// İLKOKUL

{
  id: "core_riba_primary_student",
  activityId: "riba_primary_student",

  timing: {
    type: "month",
    month: 5
  },

  applicableSchoolLevels: ["primary"],
  selectionMode: "default",
  order: 130
},

{
  id: "core_riba_primary_teacher",
  activityId: "riba_primary_teacher",

  timing: {
    type: "month",
    month: 5
  },

  applicableSchoolLevels: ["primary"],
  selectionMode: "default",
  order: 140
},

{
  id: "core_riba_primary_parent",
  activityId: "riba_primary_parent",

  timing: {
    type: "month",
    month: 5
  },

  applicableSchoolLevels: ["primary"],
  selectionMode: "default",
  order: 150
},


// ORTAOKUL

{
  id: "core_riba_middle_student",
  activityId: "riba_middle_student",

  timing: {
    type: "month",
    month: 5
  },

  applicableSchoolLevels: ["middle_school"],
  selectionMode: "default",
  order: 160
},

{
  id: "core_riba_middle_teacher",
  activityId: "riba_middle_teacher",

  timing: {
    type: "month",
    month: 5
  },

  applicableSchoolLevels: ["middle_school"],
  selectionMode: "default",
  order: 170
},

{
  id: "core_riba_middle_parent",
  activityId: "riba_middle_parent",

  timing: {
    type: "month",
    month: 5
  },

  applicableSchoolLevels: ["middle_school"],
  selectionMode: "default",
  order: 180
},


// LİSE

{
  id: "core_riba_high_student",
  activityId: "riba_high_student",

  mebbisCode:
    "B.K.A.17.a.1",

  activityTypeId:
    "individual_recognition_techniques",

  timing: {
    type: "month",
    month: 5
  },

  applicableSchoolLevels: [
    "high_school",
    "vocational_high_school"
  ],

  selectionMode: "default",
  order: 190
},

{
  id: "core_riba_high_teacher",
  activityId: "riba_high_teacher",
  
  mebbisCode:
    "B.K.A.21.a.1",

  activityTypeId:
    "individual_recognition_techniques",

  timing: {
    type: "month",
    month: 5
  },

  applicableSchoolLevels: [
    "high_school",
    "vocational_high_school"
  ],

  selectionMode: "default",
  order: 200
},

{
  id: "core_riba_high_parent",
  activityId: "riba_high_parent",
  
  mebbisCode:
    "B.K.A.25.a.1",

  activityTypeId:
    "individual_recognition_techniques",

  timing: {
    type: "month",
    month: 5
  },

  applicableSchoolLevels: [
    "high_school",
    "vocational_high_school"
  ],

  selectionMode: "default",
  order: 210
}

];